<!-- Mobile Toolbar -->
<div class="mobile-toolbar-wrapper">
  <!-- First Row: Burger, Logo, Search -->
  <div class="mobile-top-row">
    <div class="mobile-left-group">
      <button class="icon-button mobile-menu-button" (click)="onMenuClick()">
        <fa-icon [icon]="isSidenavOpen() ? faXmark : faBars"></fa-icon>
      </button>

      <a class="mobile-logo-container" routerLink="home">
        <img class="mobile-logo" [src]="logo" alt="DottNet Logo" />
      </a>
    </div>

    <button class="icon-button mobile-search-button" (click)="openSearch()">
      <fa-icon [icon]="faSearch"></fa-icon>
    </button>
  </div>

  <!-- Second Row: Categories -->
  @if (isSearchOpen()) {
    <div class="mobile-search-row flex-row flex-align-center">
      <input
        type="text"
        class="mobile-search-input"
        placeholder="Cerca qualcosa..."
        [ngModel]="searchTextInternal()"
        (ngModelChange)="searchTextInternal.set($event)"
        (keydown.enter)="searchTextResult()"
        (keydown.escape)="closeSearch()"
        [attr.aria-invalid]="showTooShort()"
        aria-describedby="mobile-search-error"
        autofocus
      />
      <button class="icon-button mobile-search-submit" (click)="searchTextResult()">
        <fa-icon [icon]="faSearch"></fa-icon>
      </button>
      <button class="icon-button mobile-search-close" (click)="closeSearch()">
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
      @if (showTooShort()) {
        <span id="mobile-search-error" class="search-error" role="alert">{{ 'dottnet.search.toofewcharacters' | translate }}</span>
      }
    </div>
  } @else {
    <div class="mobile-categories-wrapper">
      @if (mobileCanScrollLeft()) {
        <div class="mobile-scroll-indicator mobile-scroll-left" (click)="scrollMobileCategoriesLeft()">
          <fa-icon [icon]="faChevronLeft"></fa-icon>
        </div>
      }
      <div class="mobile-categories-row" #mobileCategoriesContainer (scroll)="updateMobileScrollState()">
        @for (topic of visibleTopics(); track topic.topicID; let last = $last) {
          <button mat-button class="mobile-category-button" (click)="onTopicClick(topic)">
            {{ topic.topicDescription | titlecase }}
          </button>
          @if (!last) {
            <div class="mobile-category-separator">|</div>
          }
        }
      </div>
      @if (mobileCanScrollRight()) {
        <div class="mobile-scroll-indicator mobile-scroll-right" (click)="scrollMobileCategoriesRight()">
          <fa-icon [icon]="faChevronRight"></fa-icon>
        </div>
      }
    </div>
  }
</div>

<!-- Desktop Toolbar -->
<div class="desktop-toolbar-wrapper">
  <!-- First Row: Logo and Banner -->
  <div class="toolbar-top-row flex-row flex-justify-start flex-align-center">
    <a class="logo-container" routerLink="home">
      <img class="toolbar-logo" [src]="logo" alt="DottNet Logo" />
    </a>
    <!-- Header Banner -->
    <dottnet-header-banner [items]="headerBannerItems()"></dottnet-header-banner>
  </div>

  <!-- Second Row: Navigation Bar -->
  <div class="toolbar-nav-row flex-row">
    <!-- Div 1: Hamburger Menu -->
    <div class="menu-container flex-row flex-align-center">
      <button class="icon-button menu-button" (click)="onMenuClick()">
        <fa-icon [icon]="isSidenavOpen() ? faXmark : faBars"></fa-icon>
      </button>
    </div>

    <!-- Div 2: Categories or Search Input -->
    @if (isSearchOpen()) {
      <div class="search-container flex-row flex-align-center">
        <input
          type="text"
          class="search-input"
          placeholder="Cerca qualcosa..."
          [ngModel]="searchTextInternal()"
          (ngModelChange)="searchTextInternal.set($event)"
          (keydown.enter)="searchTextResult()"
          (keydown.escape)="closeSearch()"
          [attr.aria-invalid]="showTooShort()"
          aria-describedby="search-error"
          autofocus
        />
        <button class="icon-button search-submit-button" (click)="searchTextResult()">
          <fa-icon [icon]="faSearch"></fa-icon>
        </button>
        @if (showTooShort()) {
          <span id="search-error" class="search-error" role="alert">{{ 'dottnet.search.toofewcharacters' | translate }}</span>
        }
      </div>
    } @else {
      <div class="categories-wrapper">
        @if (canScrollLeft()) {
          <div class="scroll-indicator scroll-left" (click)="scrollCategoriesLeft()">
            <fa-icon [icon]="faChevronLeft"></fa-icon>
          </div>
        }
        <div class="categories-container" #categoriesContainer (scroll)="updateScrollState()">
          @for (topic of visibleTopics(); track topic.topicID; let last = $last) {
            <button mat-button class="category-button" (click)="onTopicClick(topic)">
              {{ topic.topicDescription | titlecase }}
            </button>
            @if (!last) {
              <div class="category-separator">|</div>
            }
          }
        </div>
        @if (canScrollRight()) {
          <div class="scroll-indicator scroll-right" (click)="scrollCategoriesRight()">
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </div>
        }
      </div>
    }

    <!-- Div 3: Actions (Search + Profile) -->
    <div class="toolbar-actions flex-row flex-align-center">
      <!-- Search Button -->
      @if (isSearchOpen()) {
        <button class="icon-button close-search-button" (click)="closeSearch()">
          <fa-icon [icon]="faXmark"></fa-icon>
        </button>
      } @else {
        <button class="icon-button search-button" (click)="openSearch()">
          <fa-icon [icon]="faSearch"></fa-icon>
        </button>
      }

      <!-- Profile Button -->
      <button class="icon-button profile-button" (click)="onUserMenuClick()">
        @if (getUserInitials()) {
          <div class="profile-initials">{{ getUserInitials() }}</div>
        } @else {
          <fa-icon [icon]="faUser"></fa-icon>
        }
      </button>
    </div>
  </div>
</div>
